import BusinessLayout from "../layouts/BusinessLayout";
import OrdersPage from "../components/Orders/pages/OrdersPage";

function Orders() {
  return (
    <BusinessLayout>
      <OrdersPage />
    </BusinessLayout>
  );
}

export default Orders;